require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./identidad-personal-borges.json") })
        }
      }, "path---identidad-personal-borges");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---identidad-personal-borges!./.cache/json/identidad-personal-borges.json
// module id = 842
// module chunks = 231608221292675